export default "__VITE_ASSET__DUl6OhMv__"